import React from 'react';
import './TermsOfUse.css';

export default function ContactUs() {
  return (
    <div className="terms-page">
      <h1>Contact Us</h1>
<section>
    
    <p>
        Have questions, suggestions, or feedback for BoostYourBets.com? We'd love to hear from you!
    </p>
    <p>
        You can reach us by email at:
    </p>
    <p>
        <strong><a href="mailto:boostyourbets@gmail.com">boostyourbets@gmail.com</a></strong>
    </p>
    <p>
        We strive to respond to all inquiries as quickly as possible.
    </p>
</section>
</div>
  );
}